// extracted by mini-css-extract-plugin
export default {"accordionSideMenu":"accordion-side-menu_accordionSideMenu__+phZm"};